<template>
	<div v-if="data" class="invite_wrap">
		<div class="basic_wrap">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('index.invite')}}</div>
				
			</div>
			<div class="head-tabs">
			    <a href="#/teamhis" class="tab-item">{{$t('ihome.invest')}}</a>
			    <a href="#/teamreg" class="tab-item active">{{$t('ihome.reg')}}</a>
			</div>
			<div class="user_detail" style="text-align: center;">
				<img style="text-align: center;margin: auto; width: 50%;height: 50%; padding-top: 20px;" class="qrcode" :src="data.share_image_url" alt="" />
			</div>
			<div class="share">
			    <div class="share_box">
			        <div>
			            <div style="background-image: url('../images/user/coin.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;"></div>
			            <img src="../images/user/coin.png" draggable="true"></div>
			        <div class="c-white ft34 font-bold mb20">{{$t('team.refer')}}</div>
			        <div class="c-white ft28 font-bold mb50" style="opacity: 0.8;">
						{{$t('team.share')}}
			        </div>
			        <div class="copy flex alcenter flex-between">
			            <div v-clipboard="() => data.share_link" v-clipboard:success="copy"  class="invite-link">
							{{data.share_link}}
			            </div>
			            <div v-clipboard="() => data.share_link" v-clipboard:success="copy" class="copy-btn flex-center">{{$t('team.copy')}}</div>
			        </div>
			    </div>
			</div>
			<div class="user_top1">
				<div class="introduce">
				    <div class="line left_line"></div>
				    <div class="tit">{{$t('share.introduction')}}</div>
				    <div class="line right_line"></div>
				</div>
				<div class="award_tip">
					<p>{{$t('ihome.regtip1')}}{{data.mininvest}} {{utils_moneyMark()}}. </p>
					<p>{{$t('ihome.regtip2')}}</p>
				</div>
			</div>
			<div class="table-wrap">
				<table class="ui-table">
				    <thead>
				    <tr>
				        <th class="pl">{{$t('ihome.invitenum')}}：{{num}}</th>
				    </tr>
				    </thead>
				</table>	
			</div>
			<div class="table-wrap">
			    <table class="ui-table">
			        <thead>
			        <tr>
			            <th class="pl">{{$t('ihome.invite')}}</th>
			            <th>{{$t('ihome.reward')}}</th>
			            <th>{{$t('ihome.getreward')}}</th>
			        </tr>
			        </thead>
			        <tbody v-if="list">
						<tr v-for="(it,i) in list">
							<td class="pl">{{it.regs}}</td>
							<td>{{it.num}} {{utils_moneyMark()}}</td>
							<td v-if="it.ling==1">
								<span>{{$t('ihome.gotreward')}}</span>
							</td>
							<td v-else>
								<button v-if="num>=it.regs" @click="ling(it.id)" class="basic_btn btn flex-wrap font-bold">
									{{$t('ihome.getreward')}}
								</button>
								<span v-else>{{$t('ihome.disinvite')}} {{it.regs-num}}</span>
							</td>
						</tr>
			        </tbody>
			    </table>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Empty
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue.use(Empty).use(Clipboard);
	export default {
		name: "myTeam",
		data() {
			return {
				data:null,
				list:null,
				qrcode: false,
				num:0
			};
		},
		components: {
			bsHeader
		},
		created() {
			this.$parent.footer('myteam', true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/teamreg').then((r) => {
					this.data = r.data;
					this.list = r.data.rewards;
					this.num = r.data.num;
				});
			},
			ling(id){
				Fetch("/user/lingregreward", {
				  id: id
				}).then(r => {
					 this.list = r.data.rewards;
					 this.num = r.data.num;
					 this.$toast({
					     background: "#07c160",
					     message: this.$t('ihome.lingsucc'),
					 });
				}).catch(err=>{
				   
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: auto;
		padding-bottom: 10px;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		
	}
	.user_top1{
		width: 96%;
		position: relative;
		background: #D20100cc;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		margin-top: 10px;
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: center;
		    margin: 3px auto 0 auto;
			
		}
	}
	.user_top{
		width: 96%;
		position: relative;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		margin-top: 10px;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 85px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			margin-top: 10px;
			p:nth-child(1){
				font-size: 14px;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		margin-left: 2%;
		background: #FFF;
		height: 35px;
		border-radius: 5px;
		    margin-top: 10px;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
			height: 25px;
			color: #FFFFFF;
			background:#f90 ;
			margin: 5px;
		}
		.active{
			background:#746b0a;
			color: #FFFFFF;
		}
	}
	.list{
		margin-top: 5px;
		width: 96%;
		margin-left: 2%;
		background: #FFFFFF;
		border-radius: 5px;
		.item {
		    height: 52px;
		    line-height: 52px;
		    width: 314px;
		    margin: 0 auto;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    border-bottom: 1px solid #E3E4E5;
			p:nth-child(1){
		        font-size: 13px;
		        color: #000;
		        margin-left: 8px;
		    }
			p:nth-child(2){
		        flex: 1;
		        margin-left: auto;
		        text-align: right;
		        font-size: 12px;
		        color: rgba(0, 0, 0, 0.4);
		    }
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 15px;
		.basic_btn{
			margin: 15px auto;
			width: 50%;
		}
	}
	.share{
	    overflow: hidden;
	    padding: 20px 14px 0;
		.share_box{
		    position: relative;
		    width: 100%;
		    height: 213px;
		    background-size: 100% 100%;
		    padding: 52px 0 0 31px;
		    box-sizing: border-box;
			background: linear-gradient(270deg,#36333d, #746b0a);
			border-radius: 50px;
			.copy{
			    width: 300px;
			    height: 44px;
			    padding: 0 5px 0 21px;
			    background: #fff;
			    border-radius: 10px;
			    box-sizing: border-box;
				.invite-link{
				    flex: 1;
				    font-size: 11px;
				    color: #2a2a2a;
				    word-break: break-all;
				    margin-right: 10px;
					line-height: 16px;
				    box-sizing: border-box;
				}
				.copy-btn{
				    flex-shrink: 0;
				    width: 75px;
				    height: 36px;
				    border-radius: 5px;
				    background: linear-gradient(1turn,#36333d, #746b0a);
				    font-size: 13px;
				    color: #fff;
				}
			}
		}
	}
	.flex-center {
	    display: flex;
	    justify-content: center;
	    align-items: center;
	}
	.invite-link{
	    flex: 1;
	    font-size: 11px;
	    color: #2a2a2a;
	    word-break: break-all;
	    margin-right: 10px;
		line-height: 16px;
	    box-sizing: border-box;
	}
	.share_box>div:nth-child(1){
	    width: 74px;
	    height: 74px;
	    position: absolute;
	    right: 11px;
	    top: -6px;
		img{
			height: 100%;
		}
	}
	.font-bold {
	    font-weight: 700;
	}
	.mb20 {
	    margin-bottom: 10px!important;
	}
	.c-white {
	    color: #fff;
	}
	.ft28 {
	    font-size: 14px;
	}
	.mb50 {
	    margin-bottom: 26px!important;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #fff;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ababab;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.table-wrap {
	    position: relative;
	    overflow: hidden;
		margin: 10px;
		border-radius: 10px;
	}
	.ui-table {
	    margin-bottom: -1px;
	    background: #fff7f1;
	}
	.ui-table {
	    background: #fff;
	    font-size: 12px;
	}
	.ui-table {
	    width: 100%;
	    border-collapse: collapse;
	    border-spacing: 0;
	    text-align: center;
		th {
		    height: 40px;
		    background: #ffeee2;
		    font-size: 14px;
		    color: #6c3b23;
		    text-align: center;
			font-weight: 400;
		}
		 .pl {
		    padding-left: 15px;
		}
		td {
		    height: 40px;
		    color: #6d6d6d;
		    border-bottom: 1px solid #ffe8de;
		    text-align: center;
		}
	}
	.btn{
	    width: 62px;
	    height: 24px;
	    border-radius: 5px;
	    font-size: 9px;
	    color: #fff;
	    margin-right: 8px;
	    line-height: 24px;
	}
</style>
